module.exports = __webpack_public_path__ + "static/img/Jack-Viney.b037a8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Viney.jpg
// module id = kNge
// module chunks = 0